import { assetUrl, apiUrl } from "./api";

export const CONSULTANT_SKILL_OPTIONS = [
  { value: "", label: "全部方向" },
  { value: "脱单", label: "脱单" },
  { value: "婚姻修复", label: "婚姻修复" },
  { value: "情绪疗愈", label: "情绪疗愈" },
  { value: "婚前辅导", label: "婚前辅导" },
  { value: "关系成长", label: "关系成长" },
];

export function getConsultantImageUrl(url) {
  return assetUrl(url);
}

export async function fetchConsultants({
  keyword = "",
  skill = "",
  city = "",
  category = "",
  limit = null,
} = {}) {
  const params = new URLSearchParams();
  if (keyword.trim()) params.append("keyword", keyword.trim());
  if (skill) params.append("skill", skill);
  if (city) params.append("city", city);
  if (category) params.append("category", category);
  if (limit) params.append("limit", String(limit));

  const res = await fetch(apiUrl(`/api/consultants?${params.toString()}`));
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
